import React from 'react';
import { Form } from 'react-final-form';
import { DSInputText, parseFinalFormErrors } from '@saucelabs/sl-component-form';
import { Button } from '@saucelabs/ds-button';
import { Col, Row } from '@saucelabs/sl-component-grid';
import PropTypes from 'prop-types';

import { sanitizeInputAlphanumeric } from '../../utils';

const CouponCode = ({ applyCoupon, appliedCoupon, appliedCouponGivesDiscount }) => (
  <Form
    onSubmit={(values) => (
      applyCoupon(values.coupon)
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => {
          applyCoupon('');
          const parsedErrors = parseFinalFormErrors({}, response?.data?.detail?.[0]?.message);
          return parsedErrors;
        })
    )}
    render={({ form, handleSubmit }) => {
      const { values, submitError, submitting } = form.getState();
      const inputtedCouponCode = values.coupon;
      let errorMessage = '';
      if (submitError && submitError.includes('is invalid')) {
        errorMessage = 'The coupon code is not valid.';
      }
      let buttonText = 'Apply';
      if (appliedCoupon && inputtedCouponCode === appliedCoupon && appliedCouponGivesDiscount) {
        buttonText = 'Applied';
      }
      const buttonShouldBeDisabled = buttonText === 'Applied' || submitting || form.getFieldState('coupon')?.value?.length < 1;

      return (
        <form
          data-qa="couponCodeForm"
          onSubmit={handleSubmit}
        >
          <Row>
            <Col
              md={8}
              xs={6}
            >
              <DSInputText
                errorMessage={errorMessage}
                label="Coupon Code"
                name="coupon"
                parse={sanitizeInputAlphanumeric}
                placeholder="Enter code"
              />
            </Col>
            <Col >
              <Button
                className="mt-3.5"
                color="secondary"
                disabled={buttonShouldBeDisabled}
                onPress={handleSubmit}
                type="submit"
                variant="outline"
              >
                {buttonText}
              </Button>
            </Col>
          </Row>
        </form>
      );
    }}
  />
);

CouponCode.propTypes = {
  appliedCoupon: PropTypes.string.isRequired,
  appliedCouponGivesDiscount: PropTypes.bool.isRequired,
  applyCoupon: PropTypes.func.isRequired,
};

export default CouponCode;
